import * as React from 'react'

import { ReactComponent, Subtract } from '../../types'

export interface InjectedToggleProps {
  isActive: boolean
  activate: () => void
  deactivate: () => void
  toggle: () => void
}

interface WrappedComponentProps {
  activeOnInit?: boolean
}

interface State {
  active: boolean
}

const toggleCallBack =
  (state: State) => ({ active: !state.active })

function withToggle<BaseProps extends InjectedToggleProps> (Component: ReactComponent<BaseProps>) {
  type Props = Subtract<BaseProps, InjectedToggleProps> & WrappedComponentProps

  return class extends React.Component<Props, State> {
    public state = { active: Boolean(this.props.activeOnInit) }

    public shouldComponentUpdate (nextProps: Props, nextState: State) {
      return (this.props !== nextProps || this.state !== nextState)
    }

    public render () {
      return (
        <Component
          isActive={this.state.active}
          activate={this.activate}
          deactivate={this.deactivate}
          toggle={this.toggle}
          {...this.props}
        />
      )
    }

    private activate = () => {
      this.setState(({ active: true }))
    }

    private deactivate = () => {
      this.setState(({ active: false }))
    }

    private toggle = () => {
      this.setState(toggleCallBack)
    }
  }
}

export default withToggle



// WEBPACK FOOTER //
// ./src/components/hocs/withToggle.tsx